export const Options = [
    'animal',
    'marine animal',
     'fruit',
     'flower', 
     'nature',
     'vegetable',
     'lifestyle',
     'lighthouse',
     'bokeh',
     'model',
     'cooking',
     'insect',
     'sky',
     'road',
     'mountain',
     'space',
     'planet',
     'sun',
     'moon',
     'star',
     'galaxy',
     'astrophotography',
     'cycle',
     'bike',
     'car',
     'bird',
     'milkyway',
     'forest',
     'rock',
     'desert',
     'football',
     'cricket',
     'baseball',
     'city',
     'furniture',
     'laptop',
     'mobile',
     'computer',
     'food',
     'console',
     'others'
  ];